import { render, staticRenderFns } from "./UiMediaUploader.vue?vue&type=template&id=01741757&scoped=true&"
import script from "./UiMediaUploader.vue?vue&type=script&lang=js&"
export * from "./UiMediaUploader.vue?vue&type=script&lang=js&"
import style0 from "./UiMediaUploader.vue?vue&type=style&index=0&id=01741757&prod&lang=postcss&"
import style1 from "./UiMediaUploader.vue?vue&type=style&index=1&id=01741757&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01741757",
  null
  
)

export default component.exports